import React from "react";

import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import { Button } from "../../../common/Button/Button";
import { X } from "react-feather";

import CheckboxContainer from "../../../common/CheckboxContainer/CheckboxContainer";
import Spinner from "../../../common/Spinner/Spinner";

export default function AssignExternalServicePartnerModalNew(props) {
  return (
    <Modal className="conv-pt40"
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="conv-width-30p">
      <div className="p-2 modals-headers-bar">
						<span>Assign External Service Partner</span>
						<button
							type="button"
							className="close"
							aria-label="Close"
							onClick={() => props.toggleModal(!props.isOpen)}
						>
							<X
								style={{ pointerEvents: "none" }}
								color="white"
							/>
						</button>
					</div>{" "}
        <div
          className={`m-3 ${props.isLoading && "set-opacity"}`}
          style={{ maxHeight: "400px",overflowY:"scroll", overflowX:"hidden"}}
        >
          {props.isLoading && (
            <>
              <Spinner className="center" />
            </>
          )}
          <CheckboxContainer
            toggleSelection={props.toggleServicePartner}
            checkboxItemsList={props.servicePartnerList}
          />
        </div>
        <div style={{ margin: "5px 20px" }}>
          <Button onClick={() => {
            props.saveServicePartner()
            props.deleteAppointment()
          }}>Save</Button>
          <span className="ml-4 cursor-pointer" onClick={props.toggleModal}>
            Cancel
          </span>
        </div>
      </ModalContent>
    </Modal>
  );
}
